import type { FC, ReactNode } from 'react'
import type { BreadcrumbItem } from '@/components/ds/breadcrumb'

import { cn } from '@/lib/utils'
import { Breadcrumb } from '@/components/ds/breadcrumb'
import { ConfluenceHint } from '@/components/generals/confluence-hint'

interface PageContainerProps {
    children: ReactNode
    className?: string
}

export const PageContainer: FC<PageContainerProps> = ({ children, className }): ReactNode => {
    return (
        <div className={cn('mx-auto w-full max-w-[1240px] px-4 py-6 sm:px-6 lg:px-8 lg:py-8', className)}>
            {children}
        </div>
    )
}

interface PageHeaderProps {
    title: string
    description?: ReactNode
    breadcrumb?: BreadcrumbItem[]
    actions?: ReactNode
    hint?: string
    eyebrow?: ReactNode
    className?: string
}

export const PageHeader: FC<PageHeaderProps> = ({
    title,
    description,
    breadcrumb,
    actions,
    hint,
    eyebrow,
    className
}): ReactNode => {
    return (
        <div className={cn('relative flex flex-col gap-4', className)}>
            {hint && <ConfluenceHint id={hint} />}

            {breadcrumb && <Breadcrumb items={breadcrumb} />}

            <div className='flex flex-col gap-4 md:flex-row md:items-end md:justify-between'>
                <div className='flex max-w-3xl flex-col gap-2'>
                    {eyebrow}

                    <h1 className='text-h1 text-navy'>
                        {title}
                    </h1>

                    {description && (
                        <div className='text-body text-muted-foreground'>
                            {description}
                        </div>
                    )}
                </div>

                {actions && (
                    <div className='flex shrink-0 flex-wrap items-center gap-2'>
                        {actions}
                    </div>
                )}
            </div>
        </div>
    )
}
